import { PASSAGE_TYPE, PassageContent } from "src/modules/pe-landing-module/data/interfaces"
import useComponentData from "src/modules/pe-landing-module/hooks/useComponentData"
import { IPrimitiveProps } from "../section/Primitive"
import SyncPassagePrimitive from "./passage/SyncPassagePrimitive"
import "../../../assets/css/passage.scss"
import HorizontalPassagePrimitive from "./passage/HorizontalPassagePrimitive"
import MasonryPassagePrimitive from "./passage/MasonryPassagePrimitive"
import SquarePassagePrimitive from "./passage/SquarePassagePrimitive"

/* Protopia Ecosystem component */  
const PassagePrimitive = (props: IPrimitiveProps): JSX.Element => {  
    const primitive: PassageContent  = useComponentData<PassageContent>(( props.primitive || {dimensions: {}} ) as PassageContent )
    if(!primitive.items?.length) return <></>
    switch(primitive.passageType) {
        case PASSAGE_TYPE.SQUARE: 
            return <SquarePassagePrimitive {...props} />
        case PASSAGE_TYPE.MASONRY: 
            return <MasonryPassagePrimitive {...props} />
        case PASSAGE_TYPE.HORIZONTAL: 
            return <HorizontalPassagePrimitive {...props} />
        case PASSAGE_TYPE.SYNCHRONOUS:
        default:
            return <SyncPassagePrimitive {...props} />
    }
}

export default PassagePrimitive